import { render, staticRenderFns } from "./QuizNav.vue?vue&type=template&id=e21f0e30&scoped=true&"
import script from "./QuizNav.vue?vue&type=script&lang=js&"
export * from "./QuizNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21f0e30",
  null
  
)

export default component.exports